<!-- Hero -->
<section class="page-banner" >
    <div class="hero__img">
      <img src="assets/images/banner.png" style="min-height: 450px; max-height: 500px;"/>
    </div>
    <div class="hero__caption">
      <div class="container-fluid">
        <h1 class="hero-title-ar font-bold">مركز الاسكندرية للدراسات الاقتصادية</h1>
        <p class="hero-title-en m-0">تابع الغرفة التجارية المصرية بالأسكندرية</p>
        <hr style="width: 50%;height: 1px; background-color: rgba(255, 255, 255, 1); margin-top: 60px;">
        <xng-breadcrumb  separator="&raquo;"></xng-breadcrumb> 

       </div>
  
  
   
  
    </div>
  </section> 